import { FileController, IFile, PreviewState } from './definitions';
import { useState } from 'react';

export const useFileProvider = (): FileController => {
  const [previewState, setPreviewState] = useState<PreviewState | undefined>(undefined);

  const previewFiles = (previewFileList: IFile[], previewFileName?: string) => {
    const fileList = previewFileList.map((f) => {
      let fileType = '';
      if (!f.contentBytes) {
        return f;
      } else if (f.contentType.toLowerCase().includes('image')) {
        fileType = 'image';
      } else if (f.contentType.toLowerCase().includes('video')) {
        fileType = 'video';
      } else if (f.contentType.toLowerCase().includes('text')) {
        fileType = 'text';
      } else if (f.contentType.toLowerCase().includes('pdf')) {
        fileType = 'pdf';
      }

      const cleanContentBytes = f.contentBytes!.replace(/^data:.+;base64,/, '');
      const byteCharacters = atob(cleanContentBytes);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const fileDataUrl = URL.createObjectURL(new Blob([byteArray], { type: f.contentType }));

      return {
        ...f,
        fileType,
        fileDataUrl
      } as IFile;
    });

    let previewFileIndex = -1;
    if (Boolean(previewFileName)) {
      previewFileIndex = previewFileList.findIndex((f) => f.fileName === previewFileName);
    }
    setPreviewState({ fileList, selectedFile: fileList[previewFileIndex === -1 ? 0 : previewFileIndex] });
  };

  const clearPreview = () => {
    setPreviewState(undefined);
  };

  return {
    previewState,
    previewFiles,
    clearPreview
  };
};

export default useFileProvider;
